export default __webpack_public_path__ + "static/media/logo-checkout.df65f802.png";